import { useCallback, useEffect, useRef } from 'react';
import { USER_SESSION_TIMEOUT } from '../constants';

export const useIdleTimer = (redirectUrlOrCallback: string | (() => void)) => {
  const timeOutAction = useRef<number | null>(null);

  const resetTimer = useCallback(() => {
    if (timeOutAction.current) {
      clearTimeout(timeOutAction.current);
    }

    timeOutAction.current = window.setTimeout(() => {
      if (typeof redirectUrlOrCallback === 'string') {
        window.location.assign(redirectUrlOrCallback);
      } else {
        redirectUrlOrCallback();
      }
    }, USER_SESSION_TIMEOUT);
  }, [redirectUrlOrCallback]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];

    resetTimer();
    events.forEach(event => window.addEventListener(event, resetTimer));

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      if (timeOutAction.current) {
        clearTimeout(timeOutAction.current);
      }
    };
  }, [resetTimer]);

  return resetTimer;
};
